module.exports = __webpack_public_path__ + "img/down-hp.004a3a12.png";